module.exports = __webpack_public_path__ + "img/history.3bd94985.png";